import { AuthTypes } from './AuthTypes';
let redirectingToLogin = false;

export function markAsLoggingIn() {
	redirectingToLogin = false;
}

/**
 *
 * @param {Storage} storage Instance of Storage class
 * @returns {Object} Request interceptor that adds bearer token to request if found
 * @constructor
 */
export function AuthInterceptor(storage, $timeout) {
	'ngInject';
	return {
		request: config => {
			if (!config.headers.Authorization) {
				config.headers.Authorization = AuthTypes.getHeader(config.url, storage);
			}
			return config;
		},
		responseError: response => {
			if (response.status == 401 && !redirectingToLogin) {
				redirectingToLogin = true;
				storage.removeItem('jwt');
				if (window.isBookmarklet) {
					// bookmarklet will auto-forward to mobile login page
				} else if (window.isMobile) {
					window.location.href = `?cb=${+new Date()}&authmsg=${encodeURIComponent(
						'Your session has expired. Please log in again.'
					)}#/auth/login`;
				} else {
					$timeout(() => {
						window.location.href = `/logout?afterLogin=${encodeURIComponent(window.location.href)}`;
					});
				}
			}
			return response;
		},
	};
}
